import Header from '../Header1';
import "../../styles/grid.css";
import Vector from "../../assets/svg/editIcon.svg";
import Delete from "../../assets/svg/DeleteIcon.svg";
import { useState, useRef, useEffect } from "react";
import DatePicker from "../../Component/DatePicker";
import ReactPaginate from "react-paginate";
import axiosInstance from '../../axiosInstance';
import { ToastContainer, toast } from "react-toastify";
import { useNavigate } from 'react-router-dom';
import { useDispatch } from "react-redux";
import { resetCategories } from "../../Redux/CategorySlice";
import ConfirmDialog from '../../ConfirmDialog/ConfirmDialog';
import CommonFooter from '../../CommonFooter/CommonFooter';
import { useGlobal } from '../../GlobalContext';


const Template = () => {

  const { rolePermissionList } = useGlobal();

  // True when the role has the given permission for the named menu.
  const checkPermission = (menuName, permission) =>
    rolePermissionList.some((element) => element.name === menuName && element[permission] === true);

  const [tableData, setTableData] = useState([]);
  const [error, setError] = useState(null);
  const [limit, setLimit] = useState(5);
  const [currentPage, setCurrentPage] = useState(0);
  const [skip, setSkip] = useState(0);
  const [total, setTotal] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const popupRef = useRef(null);
  const [editData, setEditData] = useState(null);
  const [reload, setReload] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [deleteId, setDeleteId] = useState(null);

  const fetchData = async (search = '') => {
    try {
      const response = await axiosInstance.get(`/costsolution/templatecostlines`, {
        params: { limit, skip, search }
      });
      const data = response.data;
      if (Array.isArray(data.templateproject)) {
        setTableData(data.templateproject);
        setTotal(data.totalCount || 0);
        setTotalPages(Math.ceil((data.totalCount || 0) / limit));
      } else {
        setTableData([]);
      }
    } catch (error) {
      setError(error.message);
      console.error("Fetch error:", error);
      toast.error("Failed to fetch templates");
    }
  };

  useEffect(() => {
    fetchData(searchTerm);
  }, [skip, limit, reload, searchTerm]);

  const handlePageClick = ({ selected }) => {
    setCurrentPage(selected);
    setSkip(selected * limit);
  };

  const handleLimitChange = (e) => {
    const newLimit = Number(e.target.value);
    setLimit(newLimit);
    setCurrentPage(0);
    setSkip(0);
  };

  const handleAddNewClick = () => {
    dispatch(resetCategories());
    navigate("/TemplateCreation");
  };

  const handleRowSelect = (id) => {
    setSelectedRows(prev =>
      prev.includes(id) ? prev.filter(rowId => rowId !== id) : [...prev, id]
    );
  };

  const isAllSelected = selectedRows.length === tableData.length;
  const isAnySelected = selectedRows.length > 0;

  const handleSelectAll = () => {
    setSelectedRows(isAllSelected ? [] : tableData.map((row) => row.id));
  };

  const handleEditClick = (template) => {
    navigate("/TemplateCreation", {
      state: { templateId: template.id, templateData: template }
    });
  };

  const handleDeleteRow = (id) => {
    setDeleteId(id);
    setConfirmOpen(true);
  };

  const confirmDelete = async () => {
    try {
      await axiosInstance.delete(`/costsolution/template/delete/${deleteId}`);
      toast.success("Template deleted successfully!");
      setTableData(prev => prev.filter(row => row.id !== deleteId));
      setTotal(prev => prev - 1);
      setSelectedRows([]);
      setReload(prev => !prev);
    } catch (error) {
      console.error("Delete error:", error);
      toast.error("Something went wrong while deleting!");
    } finally {
      setConfirmOpen(false);
      setDeleteId(null);
    }
  };

  const cancelDelete = () => {
    setConfirmOpen(false);
    setDeleteId(null);
  };

  // Common search handler
  const handleSearch = (term) => {
    setSearchTerm(term);
    setCurrentPage(0);
    setSkip(0);
  };

  return (
    <>
      <Header onSearch={handleSearch} />
      <div className="container">
        <div className="header">
          <div className="left-header">
            <h3>All Templates ({total})</h3>
          </div>
          <div className="right-header">
            {/* <DatePicker onDateChange={() => {}} /> */}

            {checkPermission("Template", "create_permission") && !isAnySelected && (
              <button id="addNewBtn" onClick={() => handleAddNewClick({})}>
                Add New
              </button>
            )}

          </div>
        </div>
        <table>
          <thead>
            <tr>
              <th style={{ width: "1px" }}>
                <input type="checkbox" checked={isAllSelected} onChange={handleSelectAll} />
              </th>
              <th>S.No</th>
              <th>Template</th>
              <th>Date</th>
              <th>Status</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {tableData.length > 0 ? (
              tableData.map((row, index) => (
                <tr key={row.id}>
                  <td>
                    <input
                      type="checkbox"
                      checked={selectedRows.includes(row.id)}
                      onChange={() => handleRowSelect(row.id)}
                    />
                  </td>
                  <td>{skip + index + 1}</td>
                  <td>{row.template_name}</td>
                  <td>{row.modifieddate || row.date}</td>
                  <td>
                    <span
                      style={{
                        display: "inline-flex",
                        alignItems: "center",
                        gap: "6px",
                        padding: "4px 10px",
                        borderRadius: "12px",
                        backgroundColor: row.status ? "#d4edda" : "#f8d7da",
                        color: row.status ? "#155724" : "#721c24",

                      }}
                    >
                      {/* Dot */}
                      <span
                        style={{
                          width: "8px",
                          height: "8px",
                          borderRadius: "50%",
                          backgroundColor: row.status ? "#28a745" : "#dc3545",
                          display: "inline-block",
                        }}
                      ></span>

                      {/* Status Text */}
                      {row.status ? "Active" : "Inactive"}
                    </span>
                  </td>
                  <td>
                    <div className="actions">

                      {checkPermission("Template", "edit_permission") && (
                        <span className="edit-icon">
                          <img
                            src={Vector}
                            alt="Edit Icon"
                            width="20"
                            height="20"
                            onClick={() => handleEditClick(row)}
                          />
                        </span>
                      )}

                      {checkPermission("Template", "delete_permission") && (
                        <span
                          className="delete-icon"
                          onClick={() => handleDeleteRow(row.id)}
                          style={{ cursor: "pointer" }}
                        >
                          <img src={Delete} alt="Delete Icon" width="40" height="40" />
                        </span>
                      )}

                    </div>
                  </td>
                </tr>
              ))) : (
              <tr>
                {searchTerm && tableData.length === 0 && (
                  <td colSpan="7" style={{ textAlign: 'center', padding: '20px', fontSize: '14px', color: '#666' }}>
                    No Template found matching "{searchTerm}"
                  </td>
                )}
              </tr>
            )}
          </tbody>
        </table>

        {/* Pagination Controls */}
        <div className="pagination-container d-flex align-items-center justify-content-between mt-3">
          <div className="Limit-Dropdown">
            <label htmlFor="limit" className="fw-semibold">Items per page:</label>
            <select
              id="limit"
              value={limit}
              onChange={handleLimitChange}
              className="form-select d-inline w-auto"
            >
              <option value="5">5</option>
              <option value="10">10</option>
              <option value="15">15</option>
              <option value="20">20</option>
            </select>
          </div>

          <div className="d-flex align-items-center gap-4">
            <ReactPaginate
              previousLabel={<span style={{ userSelect: "none" }}>Previous</span>}
              nextLabel={<span style={{ userSelect: "none" }}>Next</span>}
              pageCount={totalPages > 0 ? totalPages : 1}
              onPageChange={handlePageClick}
              containerClassName={"pagination d-flex"}
              activeClassName={"active"}
              marginPagesDisplayed={1}
              pageRangeDisplayed={3}
              forcePage={currentPage}
            />
          </div>
        </div>
      </div>
      <CommonFooter />
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} />
      <ConfirmDialog
        open={confirmOpen}
        title="Delete Confirmation"
        message="Are you sure you want to delete this Template?"
        confirmText="Delete"
        cancelText="Cancel"
        onConfirm={confirmDelete}
        onCancel={cancelDelete}
      />
    </>
  );
};

export default Template;